<template>
  <div class="addressBook">
    <!-- ============ 地址库界面 ============ -->
    <el-dialog :title="recipients==1?'寄件人地址簿':'收件人地址簿'"
               :visible.sync="site_list_show.flag"
               width="700px"
               :before-close="handleClose"
               @closed='closedData'
               @open='viewShow'>
      <div class="addressBook_view">
        <div class="addressBook_view_top">
          <div class="btn_view">
            <el-radio-group v-model="fbaDetails"
                            v-if="recipients==2&&isFba"
                            @change='tab_address_type'
                            size="medium">
              <el-radio-button :label="false">用户地址</el-radio-button>
              <el-radio-button :label="true">FBA地址</el-radio-button>
            </el-radio-group>
            <div v-else></div>
            <el-button size="small"
                       v-if="!fbaDetails"
                       @click="addAddress"> <i class="el-icon-plus"></i> 添加地址</el-button>
            <div class="btn_searcg"
                 v-if="fbaDetails">
              <el-input v-model="fbaCode"
                        size="small"
                        placeholder="输入FBA仓库代码查询"></el-input>
              <el-button type="info"
                         class="inquire"
                         size="small"
                         @click="resetInquireWarehouse">重置</el-button>
              <el-button type="primary"
                         size="small"
                         @click="inquireWarehouse">查询</el-button>
            </div>
          </div>

        </div>

        <div class="addressBook_view_content">
          <el-radio-group v-model="active_id">
            <el-table :data="state_info"
                      :row-class-name="tableRowClassName"
                      v-loading="tableLoading"
                      @row-click='rowClick'
                      empty-text='地址为空'
                      style="width: 100%">
              <el-table-column width="55">
                <template slot-scope="scope">
                  <el-radio :label="scope.row.id">{{''}}</el-radio>
                </template>
              </el-table-column>

              <!-- 用户-->
              <el-table-column label="联系人"
                               v-if="!fbaDetails"
                               width="140">
                <template slot-scope="scope">
                  <div class="linkman">
                    <div class="usname">{{scope.row.username}}</div>
                    <div class="mobile">{{scope.row.mobile}}</div>
                  </div>
                </template>
              </el-table-column>

              <!-- fba -->
              <el-table-column label="仓库代码"
                               v-else
                               width="100">
                <template slot-scope="scope">
                  <div class="linkman">
                    <div class="usname">{{scope.row.code}}</div>
                  </div>
                </template>
              </el-table-column>

              <!-- 用户 -->
              <el-table-column label="地址"
                               v-if="!fbaDetails"
                               width="180">
                <template slot-scope="scope">
                  <div class="linkman">
                    <div class="usname">{{scope.row.gjname+scope.row.province+scope.row.city+scope.row.district}}</div>
                    <div class="mobile">{{scope.row.address}}</div>
                  </div>
                </template>
              </el-table-column>

              <!-- fba -->
              <el-table-column label="仓库地址"
                               v-else
                               width="200">
                <template slot-scope="scope">
                  <div class="linkman">
                    <div class="usname">{{scope.row.city}}</div>
                    <div class="mobile">{{scope.row.address}}</div>
                  </div>
                </template>
              </el-table-column>

              <!-- 用户 -->
              <el-table-column prop="address"
                               label="公司名"
                               v-if="!fbaDetails">
                <template slot-scope="scope">
                  <div class="linkman">
                    <div class="usname">{{scope.row.companyname||'无公司名'}}</div>
                    <div class="mobile">{{scope.row.companytaxid||'无统编'}}</div>
                  </div>
                </template>
              </el-table-column>

              <!-- fba -->
              <el-table-column prop="address"
                               label="邮政编码"
                               v-else>
                <template slot-scope="scope">
                  <div class="linkman">
                    <div class="code">{{scope.row.zipcode}}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="address"
                               v-if="!fbaDetails"
                               label="操作">
                <template slot-scope="scope">
                  <div class="operation">
                    <el-tooltip class="item"
                                effect="dark"
                                content="编辑"
                                transition='el-zoom-in-bottom'
                                placement="top">
                      <el-button icon="el-icon-edit"
                                 circle
                                 @click.stop="clickShowModification($event,scope.row)"
                                 size="mini"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item"
                                effect="dark"
                                transition='el-zoom-in-bottom'
                                content="删除"
                                placement="top">
                      <el-button icon="el-icon-delete"
                                 type="danger"
                                 @click.stop="clickRemove($event,scope.row.id)"
                                 circle
                                 size="mini"></el-button>
                    </el-tooltip>
                  </div>

                </template>
              </el-table-column>
            </el-table>
          </el-radio-group>
          <el-pagination background
                         layout="prev, pager, next"
                         :page-size='pageSize'
                         :current-page.sync='page'
                         @current-change='currentChange'
                         :total="pageNum">
          </el-pagination>
        </div>

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="site_list_show.flag = false">取 消</el-button>
        <el-button type="primary"
                   @click="funCallBack">确 定</el-button>
      </span>
    </el-dialog>

    <!-- ============ 修改地址库界面 ============ -->
    <el-dialog :title="whetherChange?address_data.type==3?'FBA地址':'更改地址':'添加地址'"
               :visible.sync="amendAddress"
               width="700px">
      <el-form label-position="top"
               ref="edit_ruleForm"
               :model="address_data"
               label-width="80px">
        <el-form-item class="place_order_form_item"
                      prop="username"
                      :rules="[{required: true, message: '联系人姓名不能为空'}]"
                      :label="address_data.type==3?'仓库代码':'姓名'">
          <el-input v-model="address_data.username"
                    placeholder="请填写联系人姓名"></el-input>
        </el-form-item>

        <el-form-item class="place_order_form_item"
                      label="公司名称"
                      v-if="address_data.type!=3">
          <el-input v-model="address_data.companyname"
                    placeholder="请填写公司名称"></el-input>
        </el-form-item>

        <el-form-item class="place_order_form_item"
                      label="电话"
                      v-if="address_data.type!=3"
                      prop="mobile"
                      :rules="[{required: true, message: '联系电话不能为空'}]">
          <el-input v-model="address_data.mobile"
                    placeholder="请填写联系电话"></el-input>
        </el-form-item>

        <el-form-item class="place_order_form_item"
                      label="统一税号"
                      v-if="address_data.type!=3"
                      prop="companytaxid">
          <el-input v-model="address_data.companytaxid"
                    placeholder="请填写统一编号"></el-input>
        </el-form-item>

        <el-form-item class="place_order_form_item"
                      prop="site"
                      v-if="address_data.type!=3"
                      :rules="[{required: true, message: '省市区不能为空',trigger: 'change'}]"
                      label="省市区">
          <el-cascader v-model="address_data.site"
                       placeholder="请选择您所在的地区"
                       :options="siteData"></el-cascader>
        </el-form-item>

        <el-form-item class="place_order_form_item"
                      prop="site"
                      v-if="address_data.type==3"
                      :rules="[{required: true, message: '省市区不能为空',trigger: 'change'}]"
                      label="FBA仓库城市">
          <el-input v-model="address_data.city"
                    placeholder="请输入FBA仓库所在城市（英文）"></el-input>
        </el-form-item>

        <el-form-item class="place_order_form_item"
                      prop="zipcode"
                      :rules="recipients==2?[{required: true, message: '邮政编码不能为空'}]:[]"
                      label="邮政编码">
          <el-input v-model="address_data.zipcode"
                    placeholder="请填写邮政编码"></el-input>
        </el-form-item>

        <el-form-item class="place_order_form_item_max"
                      prop="address"
                      :rules="[{required: true, message: '详细地址不能为空'}]"
                      label="详细地址">
          <el-input v-model="address_data.address"
                    placeholder="请填写所在街道以及详细地址">
          </el-input>
        </el-form-item>

        <el-form-item class="place_order_form_item_maxs"
                      label-position='left'
                      prop="detailedAddress"
                      label="是否为默认地址">
          <el-switch v-model="address_data.isdefault"
                     active-color="#13ce66"
                     active-value='1'
                     inactive-value='0'
                     inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="amendAddress = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmAE">{{whetherChange?'修 改':'添 加'}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { apiAddressBook, apiZHCN, apiFba, apiSite } from '@/request/api'
import common from '../assets/js/common'
export default {
  name: 'addressBook',
  data () {
    return {
      optionProps: {
        children: 'province',
        label: 'label',
        value: 'value'
      },
      // ----------被选中的值-----------
      active_item: {},
      // ----------fab仓库码搜索-----------
      fbaCode: '',
      // ----------加载-----------
      tableLoading: false,
      // ----------地址信息-----------
      address_data: {
        username: '',
        companyname: '',
        mobile: '',
        companytaxid: '',
        site: [],
        address: '',
        zipcode: '',
        isdefault: false
      },
      //   -------修改地址库-------
      amendAddress: false,
      //   -------是否为更改地址-------
      whetherChange: false,
      // -------选中的地址ID------
      active_id: '',
      // -------中国地址------
      cn_data: [],
      // -------FBA仓库详情显示------
      fbaDetails: false,

      //--------页码数据--------
      page: 1,
      pageSize: 8,
      pageNum: 10,
      //--------地址数据--------
      state_info: [],
      //--------地址数据--------
      active_site_data: []
    }
  },
  computed: {
    siteData () {
      return this.recipients == 1 ? this.cn_data : this.active_site_data
    }
  },
  methods: {
    //   -------事件回调-------
    funCallBack () {
      this.$emit('submitpack', this.active_id, this.active_item)
      this.site_list_show.flag = false
    },
    //   -------关闭组件清空数据-------
    closedData () {
      this.fbaDetails = false
      this.page = 1
      this.active_item = {}
    },
    //   -------查询仓库代码-------
    inquireWarehouse () {
      this.page = 1
      this.getFBA(this.fbaCode)
    },
    //   -------重置fba查询-------
    resetInquireWarehouse () {
      this.page = 1
      this.fbaCode = ''
      this.getFBA()
    },
    //   -------切换地址库类型数据-------
    tab_address_type (e) {
      this.page = 1
      if (e) {
        this.getFBA()
      } else {
        this.getAddressData()
      }
    },
    //   -------赋予状态-------
    tableRowClassName ({ row, rowIndex }) {
      if (row.isdefault == 1) {
        return 'success-row';
      } else if (rowIndex % 2 == 0) {
        return 'info-row';
      }
      return '';
    },
    //   -------修改页码-------
    currentChange () {
      if (this.fbaDetails) {
        this.getFBA()
      } else {
        this.getAddressData()
      }
    },
    //   -------确定添加地址/修改-------
    async confirmAE () {
      this.$refs.edit_ruleForm.validate(async (valid) => {
        if (valid) {
          let res = await apiAddressBook({
            op: 'address',
            type: this.address_data.type,
            isdefault: this.address_data.isdefault,
            addid: this.whetherChange ? this.address_data.id : '',
            gjid: this.recipients == 1 ? '' : this.addressLibrary ? this.address_data.site[0] : this.stateId,
            "address[gj]": this.recipients == 1 ? 'CH-中国' : '',
            "address[username]": this.address_data.username,
            "address[mobile]": this.address_data.mobile,
            "address[address]": this.address_data.address,
            'address[zipcode]': this.address_data.zipcode,
            'address[companytaxid]': this.address_data.companytaxid,
            'address[companyname]': this.address_data.companyname,
            'address[province]': this.addressLibrary ? this.address_data.site[1] : this.address_data.site[0],
            'address[city]': this.address_data.type == 3 ? this.address_data.city : this.addressLibrary ? this.address_data.site[2] : this.address_data.site[1],
            'address[disteict]': this.addressLibrary ? this.address_data.site[3] : this.address_data.site[2],
          })
          if (res.errno == 0) {
            this.$message.success(res.message)
            this.amendAddress = false
            this.getAddressData()

          } else {
            this.$message.error(res.message)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //   -------获取当前国家数据-------
    async getActiveData () {
      let res = await apiZHCN()
      let arr = []
      for (const key in res.gjlist) {
        if (res.gjlist[key].value == this.stateId) {
          arr.push(res.gjlist[key])
        }
      }
      this.active_site_data = arr[0].children

    },
    //   -------获取所有国家数据-------
    async getAllData () {
      let res = await apiZHCN()
      let arr = []
      for (const key in res.gjlist) {
        if (arr.length == 33) {
          console.log(res.gjlist[key]);
          break
        } else {
          arr.push(res.gjlist[key])
        }
      }
      this.active_site_data = arr
    },
    //   -------获取中国数据-------
    async getCnData () {
      let res = await apiZHCN({
        all: 1,
      })
      this.cn_data = res.gjlist.CN.children
    },

    //   -------点击显示增加地址-------
    addAddress () {
      this.address_data = {
        type: this.recipients,
        username: '',
        companyname: '',
        mobile: '',
        companytaxid: '',
        site: '',
        address: '',
        zipcode: '',
        isdefault: false
      }
      this.whetherChange = false
      this.amendAddress = true
    },
    //   -------点击显示修改地址-------
    clickShowModification (e, item) {
      e.stopPropagation();
      let data = JSON.parse(JSON.stringify(item))
      this.address_data = data
      this.address_data.site = [this.address_data.province, this.address_data.city]
      if (this.address_data.district != '') {
        this.address_data.site.push(this.address_data.district)
      }
      this.whetherChange = true
      this.amendAddress = true
    },
    //   -------点击删除地址-------
    clickRemove (e, id) {
      e.stopPropagation();
      this.$confirm('确定要删除该地址吗，此操作不可逆转, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await apiAddressBook({
          op: 'address',
          pd: 'delete',
          id
        })
        if (res.errno == 0) {
          this.page = 1;
          this.getAddressData()
          this.$message.success('删除成功')
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    //   -------行被点击触发-------
    rowClick (e) {
      this.active_item = e
      this.active_id = e.id
    },
    //   -------获取FBA地址数据-------
    async getFBA (fbacode) {
      this.tableLoading = true
      let res = await apiFba({
        pd: 'list',
        addrid: this.stateId,
        pageSize: this.pageSize,
        page: this.page,
        fbacode
      })
      if (res.errno == 0) {
        this.state_info = res.fbalist
        this.pageNum = parseInt(res.total, 10)
      } else {
        this.$message.error(res.message)
      }
      this.tableLoading = false
    },
    //   -------获取用户地址数据-------
    async getAddressData () {
      this.tableLoading = true
      let res = await apiAddressBook({
        op: 'address',
        type: this.recipients,
        gjid: this.recipients == 2 ? this.stateId : '',
        page: this.page,
        pageSize: this.pageSize
      })
      if (res.errno == 0) {
        this.state_info = res.list
        this.pageNum = parseInt(res.totalNum, 10)
      } else {
        this.$message.error(res.message)
      }
      this.tableLoading = false
    },
    //   -------关闭前提示-------
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    //------- 界面显示的时候-------
    viewShow () {
      this.getAddressData()
      if (this.recipients == 1) {
        this.getCnData()
      } else {
        if (this.addressLibrary) {
          this.getAllData()
        } else {
          this.getActiveData()
        }
      }
    }
  },
  props: {
    //  -------  是否为显示地址簿 -------
    addressLibrary: {
      type: Boolean,
      required: false
    },
    //  -------  是否显示地址库弹窗 -------
    site_list_show: {
      type: Object,
      required: true,
      default: () => { }
    },
    //  -------  判断是寄件地址还是收件地址 -------
    recipients: {
      type: [Number, String],
      default: 2
    },
    //  -------  是否支持fba地址-------
    isFba: {
      type: Boolean,
      default: false
    },
    //  -------  国家ID-------
    stateId: {
      type: [String, Number],
    }
  },
  created () {


  }
}
</script>

<style lang='scss'>
.addressBook {
  .el-table .info-row {
    background: #f7f7f7;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .el-dialog__body {
    padding: 30px;
  }
  .saveSite {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .el-checkbox__inner {
      border-radius: 50%;
    }
  }
  .view_title {
    width: 100%;

    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    margin-bottom: 15px;
    .title_left {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .title_right {
      .el-link {
        margin-left: 30px;
      }
    }
  }
  .title_text {
    margin-left: 10px;
    font-size: 18px;
    color: #333;
    font-weight: 700;
  }
  .el-form {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .el-form-item__label {
      padding: 0;
      height: 30px;
    }
    .el-input__inner {
      border-top: 0;
      border-left: 0;
      border-radius: 0;
      border-right: 0;
      padding-left: 0;
    }
    .el-form-item {
      //   margin-bottom: 10px;
    }
    .place_order_form_item_maxs {
      display: flex;
      width: 100%;
      //   justify-content: space-between;
      .el-form-item__content {
        margin-left: 20px;
      }
    }
    .place_order_form_item_max {
      width: 100%;
      .el-cascader {
        width: 100%;
      }
    }
    .place_order_form_item {
      width: 40%;
      .el-cascader {
        width: 100%;
      }
    }
  }
  .addressBook_view {
    .el-radio-group {
      width: 100%;
    }
    .addressBook_view_content {
      width: 100%;
      height: 580px;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .operation {
        width: 50%;
        display: flex;
        justify-content: space-between;
      }
      .linkman {
        .usname {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .mobile {
          color: #999;
        }
      }
      td {
        padding: 5px 0;
      }
      th {
        font-size: 12px;
        font-weight: normal;
      }
      tr {
        cursor: pointer;
      }
    }
    .addressBook_view_top {
      display: flex;
      flex-direction: column;
      .btn_view {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .btn_searcg {
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        .el-input {
          width: 200px;
          input {
            border-right: 0;
            border-radius: 4px 0 0 4px;
          }
        }
        .inquire {
          width: auto;
          height: 100%;
          border: 1px solid #919398;
          border-radius: 0 !important;
        }
        .el-button {
          border-radius: 0 4px 4px 0;
          margin: 0;
          //   margin-left: 10px;
        }
      }
    }
  }
}
</style>
